import React from "react";
import * as R from "ramda";
import { useTranslation } from "react-i18next";
import { Progress } from "antd";
import { useSelector } from "react-redux";

import { colors, SuccessProbabilityTag } from "./SuccessProbabilityTag";
// import { computeResult } from "./SuccessProbabilityAnswers";

import styled from "styled-components/macro";

const Percentage = styled.div`
  margin-bottom: 16px;

  &:last-child {
    margin-bottom: 0;
  }
`;

const Header = styled.div`
  display: flex;
  gap: 20px;
  font-weight: bold;
  border-bottom: 1px solid #00000024;
  padding-bottom: 0.5em;
  margin-bottom: 1.5em;

  .ant-tag {
    padding-inline: 15px;
    text-align: center;
  }
`;

const skillList = [
  "responsability",
  "pleasantness",
  "openMinded",
  "extroversion",
  "perseverance",
  "atention",
  "emotionalStability",
  "numericalSkill",
  "verbalReasoning"
];

const resultColors = R.cond([
  [R.gte(40), R.always(colors.low)],
  [R.gte(60), R.always(colors.medium)],
  [R.gte(100), R.always(colors.high)]
]);

const getProfileResult = (data, idProfile) => {
  const result = R.find(R.propEq("idProfile", idProfile), data);

  if (!result) {
    throw new Error(
      `No results found for successProbabilityProfile ${idProfile}`
    );
  }

  return result;
};

// export default function SuccessProbabilityTest({ serviceCallRequest }) {
export default function SuccessProbabilityTest({ serviceCallResultData }) {
  const { t } = useTranslation(["opportunity"]);
  const showTag = useSelector(state =>
    R.hasPath(["opportunity", "selected", "successProbabilityProfile"], state)
  );
  const tagProfile = useSelector(state =>
    R.pathOr(0, ["opportunity", "selected", "successProbabilityProfile"], state)
  );

  try {
    // const { skills, tag } = computeResult(serviceCallRequest, tagProfile);
    const { skills, tag } = getProfileResult(serviceCallResultData, tagProfile);

    return (
      <>
        <Header>
          {t(
            "opportunity:process.candidateDetails.successProbability-worcket.title"
          )}
          {showTag && <SuccessProbabilityTag tag={tag} tooltip={false} />}
        </Header>
        {skillList.map((skillName, i) => (
          <Percentage key={skillName}>
            <span>{`${t(
              `opportunity:process.candidateDetails.successProbability-worcket.${skillName}`
            )} (${skills[i]}%)`}</span>
            <Progress
              percent={skills[i] || 1}
              showInfo={false}
              strokeColor={resultColors(skills[i])}
            />
          </Percentage>
        ))}
      </>
    );
  } catch (e) {
    console.error(e);
    return (
      <div>
        <p>{t("opportunity:process.candidateDetails.testVisualizeError")}</p>
      </div>
    );
  }
}
